import { render } from "./fygfEventClub.vue?vue&type=template&id=23b083e6"
import script from "./fygfEventClub.vue?vue&type=script&lang=js"
export * from "./fygfEventClub.vue?vue&type=script&lang=js"

import "./fygfEventClub.vue?vue&type=style&index=0&id=23b083e6&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__